'use client';

import { useRouter } from 'next/navigation';

import {
    Button,
    ButtonVariant,
    IconName,
    Section,
    Title,
    TitleLevels,
    TrilogyColor,
    TypographyAlign,
} from '@bytel/trilogy-react';

import { sendBackToPreviousPageTracking } from '@comparator/helpers';

export function MobileComparatorHeader() {
    const router = useRouter();

    const handleBackClick = () => {
        sendBackToPreviousPageTracking();
        router.back();
    };

    return (
        <Section backgroundColor={TrilogyColor.NEUTRAL_FADE} className='is-relative'>
            <Title level={TitleLevels.ONE} marginless className='is-hidden-touch' typo={TypographyAlign.TEXT_CENTERED}>
                Comparer mes téléphones
            </Title>
            <Button
                variant={ButtonVariant.GHOST}
                className='is-marginless is-absolute-centered w-fit'
                iconName={IconName.ARROW_LEFT}
                onClick={() => handleBackClick()}
            >
                Retour
            </Button>
        </Section>
    );
}
